import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getTransactionFee = (data) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.GET_TRANSACTION_FEE, payload: true });

  try {

    const res = await commonService.post("/client/account/transactions-fee", data, { timeout: 300000 });
    const external = res.data;

    return external;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });

    return err.response.data;
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};